import { actionCreatorFactory } from 'typescript-fsa';
import { NAMESPACE } from './constants';

export const createAction = actionCreatorFactory(NAMESPACE);
export const setFilter = createAction<string>('SET_FILTER');
